import { useBranch } from "../contexts/BranchContext";
import { useTheme } from "../contexts/ThemeContext";
import { useLang } from "../contexts/LanguageContext";
import { motion } from "framer-motion";
import { Wine, WineOff } from "lucide-react";
import { branchGalleryUrl } from "../utils/branchGallery";

const branchLabels = { caddebostan: "Caddebostan", zeytinburnu: "Zeytinburnu" };

const heroImages = {
  caddebostan: branchGalleryUrl("caddebostan", 8),
  zeytinburnu: branchGalleryUrl("zeytinburnu", 8),
};

const flipbookUrls = {
  caddebostan: "https://online.fliphtml5.com/tepsiet/cadde-menu/",
  zeytinburnu: "https://online.fliphtml5.com/tepsiet/zeytin-menu/",
};

export default function MenuPage() {
  const { selectedBranch } = useBranch();
  const { theme } = useTheme();
  const { t } = useLang();
  const dk = theme === "dark";
  const hasAlcohol = selectedBranch === "caddebostan";

  return (
    <div data-testid="menu-page" className="min-h-screen">
      <section className="relative h-[30vh] md:h-[40vh] overflow-hidden">
        <div className="absolute inset-0 bg-[#121212]">
          <img src={heroImages[selectedBranch]} alt={t.menuPage.label} className="w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
        </div>
        <div className="relative z-10 h-full flex flex-col justify-end pb-12 md:pb-16 max-w-[1200px] mx-auto px-6">
          <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-body text-xs uppercase tracking-[0.3em] text-[#8B1A1A] mb-3">
            {branchLabels[selectedBranch]} / {t.menuPage.label}
          </motion.span>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }} className="font-heading text-4xl sm:text-5xl lg:text-6xl text-white">
            {t.menuPage.title1}<span className="italic text-[#8B1A1A]">{t.menuPage.title2}</span>
          </motion.h1>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }} className="mt-4 flex items-center gap-2">
            {hasAlcohol ? (
              <span className="inline-flex items-center gap-2 font-body text-xs text-[#8B1A1A] uppercase tracking-wider border border-[#8B1A1A]/30 px-3 py-1"><Wine className="w-3.5 h-3.5" /> {t.menuPage.alcohol}</span>
            ) : (
              <span className="inline-flex items-center gap-2 font-body text-xs text-[#999] uppercase tracking-wider border border-white/10 px-3 py-1"><WineOff className="w-3.5 h-3.5" /> {t.menuPage.noAlcohol}</span>
            )}
          </motion.div>
        </div>
      </section>

      <section className={`py-8 md:py-12 max-w-[1400px] mx-auto px-6`} data-testid="flipbook-area">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }} className="w-full">
          <iframe
            src={flipbookUrls[selectedBranch]}
            width="100%"
            height="800"
            style={{ border: "none", minHeight: "600px" }}
            allowFullScreen
            title={`Tepsi Et ${branchLabels[selectedBranch]} Menu`}
            data-testid="flipbook-iframe"
          />
        </motion.div>
      </section>
    </div>
  );
}
